import { create } from 'zustand'
import type { Session } from '@supabase/supabase-js'

export type ToolId = 'home' | 'exmarked' | 'cast' | 'foundry'

interface ToolDef {
  id: ToolId
  name: string
  description: string
  icon: string
}

export const TOOLS: ToolDef[] = [
  {
    id: 'exmarked',
    name: 'ExMarked',
    description: 'Document Vault',
    icon: 'M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6zM14 2v6h6M16 13H8M16 17H8M10 9H8',
  },
  {
    id: 'cast',
    name: 'Cast',
    description: 'Video Generator',
    icon: 'M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z',
  },
  {
    id: 'foundry',
    name: 'Foundry',
    description: 'Asset Library',
    icon: 'M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z',
  },
]

interface PlatformState {
  session: Session | null
  isAuthLoading: boolean
  activeTool: ToolId
  sidebarExpanded: boolean

  setSession: (session: Session | null) => void
  setAuthLoading: (loading: boolean) => void
  setActiveTool: (tool: ToolId) => void
  toggleSidebar: () => void
}

export const usePlatformStore = create<PlatformState>((set) => ({
  session: null,
  isAuthLoading: true,
  activeTool: 'home',
  sidebarExpanded: true,

  setSession: (session) => set({ session }),
  setAuthLoading: (isAuthLoading) => set({ isAuthLoading }),
  setActiveTool: (tool) => set({ activeTool: tool }),
  toggleSidebar: () => set((s) => ({ sidebarExpanded: !s.sidebarExpanded })),
}))
